<template>
    <BaseTabs
        :tab-ids="subtabs.map((subtab) => subtab.id)"
        :labels="tabLabels"
        :model-value="subtabs.find((subtab) => subtab.isSelected)?.id"
        content-class="pt-6"
        @update:model-value="$event && $emit('subtab-selected', $event)">
        <template v-for="subtab in subtabs" :key="subtab.id" #[`content-${subtab.id}`]>
            <slot v-if="subtab.isSelected" />
        </template>
    </BaseTabs>
</template>

<script setup lang="ts">
import BaseTabs from "~vue/components/BaseTabs.vue";
import { computed, type MaybeRef, unref } from "vue";

const { subtabs } = defineProps<{
    subtabs: ReadonlyArray<{ id: string; label: MaybeRef<string>; isSelected: boolean }>;
}>();

defineEmits<{
    "subtab-selected": [id: string];
}>();

const tabLabels = computed(() => Object.fromEntries(subtabs.map((subtab) => [subtab.id, unref(subtab.label)])));
</script>
